export default __webpack_public_path__ + "static/test-c2a96b23a10b34a6eb44fc67c73b873e.mp4";